import { VpButton, VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'

interface ManagementDialogProps {
  onRename: () => void
  onDelete: () => void
  onShare?: () => void
  renameTestId?: string
  deleteTestId?: string
  shareTestId?: string
}

export function ManagementDialog({ onRename, onDelete, onShare, renameTestId, deleteTestId, shareTestId }: Readonly<ManagementDialogProps>) {
  const { t } = useTranslation()

  return (
    <>
      <VpButton size="small" variant="tertiary" data-testid={renameTestId} onClick={onRename}>
        <VpIcon name="edit" />
        {t('favorite-views.management.rename')}
      </VpButton>
      <VpButton size="small" variant="tertiary" data-testid={deleteTestId} onClick={onDelete}>
        <VpIcon name="delete-bin" />
        {t('favorite-views.management.delete')}
      </VpButton>
      {onShare && (
        <VpButton size="small" variant="tertiary" data-testid={shareTestId} onClick={onShare}>
          <VpIcon name="share-android" />
          {t('favorite-views.management.share')}
        </VpButton>
      )}
    </>
  )
}
